import { handleActions } from 'redux-actions'

import {
  addLayersAction,
  deleteLayerAction,
  editLayerAction,
  sortLayersAction,
  setLayersKeysAction,
  setLayersDataAction,
  setLayersLegendsAction
} from '../actions/layers'

const INITIAL_STATE = {
  data: null,
  keys: [],
  layers: [
    // Default active layer
    { id: 'atlas:malhabreak_landtenure', config: { opacity: 50} },
    // { id: 'mapbiomas_col3_2016', config: {} }
  ],
  legends: {}
}

const reducer = handleActions({
  [addLayersAction]: (state, action) => {
    const nLayers = Array.from(state.layers)

    const layers = action.payload.layers
      .map(layer => ({
        id: layer,
        config: {}
      }))

    state.layers = nLayers.concat(layers)

    return state
  },
  [deleteLayerAction]: (state, action) => {
    const layers = state.layers.filter(item => item.id !== action.payload.layer)

    return { ...state, layers }
  },
  [editLayerAction]: (state, action) => {
    const layers = state.layers.map(layer => {
      if (layer.id === action.payload.layer) {
        layer.config[action.payload.config] = action.payload.value
      }

      return layer
    })

    return { ...state, layers }
  },
  [sortLayersAction]: (state, action) =>
    ({ ...state, layers: action.payload.layers }),
  [setLayersKeysAction]: (state, action) =>
    ({...state, keys: action.payload.keys}),
  [setLayersDataAction]: (state, action) =>
    ({...state, data: action.payload}),
  [setLayersLegendsAction]: (state, action) =>
    ({...state, legends: action.payload})
}, INITIAL_STATE)

export default reducer



// WEBPACK FOOTER //
// ./src/reducers/layers.js